// components
import { type InlineType } from '.';

// libraries
import styled, { css } from 'styled-components';

interface IStyledLabelWithChildrenProps {
  $inlineType: InlineType;
  $gap: number;
  $labelWidth: number | string;
  $alignItems: string;
}

export const StyledLabelWithChildren = styled.div<IStyledLabelWithChildrenProps>`
  ${({ $inlineType, $gap, $labelWidth, $alignItems }) => {
    switch ($inlineType) {
      case 'inline':
        return css`
          display: flex;
          flex-direction: row;
          align-items: ${$alignItems};
          gap: ${$gap}px;

          .lwc-label {
            width: ${typeof $labelWidth === 'number' ? `${$labelWidth}px` : $labelWidth};
            white-space: nowrap;
          }

          .lwc-children {
            flex: 1;

            > div {
              margin-bottom: 0 !important;
            }
          }
        `;
      case 'inline-block':
        return css`
          display: block;

          .lwc-label {
            display: inline-block;
            width: ${typeof $labelWidth === 'number' ? `${$labelWidth}px` : $labelWidth};
            margin-bottom: ${$gap}px;
          }

          .lwc-children {
            display: block > div {
              margin-bottom: 0 !important;
            }
          }
        `;
      case 'flex':
        return css`
          display: flex;
          flex-direction: column;
          gap: ${$gap}px;

          .lwc-label {
            width: ${typeof $labelWidth === 'number' ? `${$labelWidth}px` : $labelWidth};
          }

          .lwc-children {
            width: 100%;

            > div {
              margin-bottom: 0 !important;
            }
          }
        `;
    }
  }}
`;
